import dataUtils from '@/utils/api/dataUtils';

const PREFIX = '/user/my';

/**
 * 내 정보 조회 API
 *
 *
 * @returns {AxiosResponse} response
 *
 */
export const getMyInfo = async () => {
  return await dataUtils.getData(`/v1${PREFIX}`);
};

/**
 * 이메일 변경 요청 API
 *
 * @params {Object} data
 * @params {String} data.email
 *
 * @returns {AxiosResponse} response
 */
export const updateEmail = (data) => {
  return dataUtils.postData(`/v1${PREFIX}/update-email`, data);
};

/**
 * 이메일 변경 요청 승인 API
 *
 * @param {Object} data
 * @param {string} data.id
 * @param {string} data.code
 *
 * @returns {AxiosResponse} response
 */
export const acceptUpdateEmail = (data) => {
  return dataUtils.postData(`/v1${PREFIX}/update-email/accept`, data);
};

/**
 * 비밀번호 변경 API
 *
 * @param {Object} data
 * @param {String} data.oldPassword
 * @param {String} data.newPassword
 *
 * @returns {AxiosResponse} response
 */
export const updatePassword = (data) => {
  return dataUtils.postData(`/v1${PREFIX}/update-password`, data);
};

/**
 * 비밀번호 변경 API
 *
 * @param {Object} data
 * @param {String} data.oldPassword
 * @param {String} data.newPassword
 *
 * @returns {AxiosResponse} response
 */
export const updateSimplePassword = (data) => {
  return dataUtils.postData(`/v1${PREFIX}/update-simple-password`, data);
};
